import request from '@/service/request'
enum Api {
  GET_DICT_VALUE = '/dict-value/getDictValue',
  UPLOAD_FILE = '/architecture/upload',
  SEND_SMS = '/captcha/sendSms'
}

export default class commonService {
  /**
   * 获取快递公司列表
   * @param data
   * @returns
   */
  static getExpressCompanyList(): Promise<any> {
    return request.post('/express/expressList')
  }
  /**
   * 消息中心列表
   * @param data
   * @returns
   */
  static getMessageList(data: any): Promise<any> {
    return request.post('/msgPush/page', data)
  }

  /**
   * 将消息设为已读
   * @param data
   * @returns
   */
  static setHasRead(data: any): Promise<any> {
    return request.post('/msgPush/read', data)
  }

  /**
   * 根据字典type获取字典数据
   * @param data
   * @returns
   */
  static getListDictDataList(data: any): Promise<any> {
    return request.post('/dict-value/listDictData', data)
  }

  /**
   * 获取地址库数据
   * @param data
   * @returns
   */
  static getAddressJson(url: string, data: Record<string, any>): Promise<any> {
    return request.get(url, data)
  }

  /**
   * 获取数据字典值
   * @param data
   * @returns
   */
  static getDictValue(data: any): Promise<any> {
    return request.post(Api.GET_DICT_VALUE, data)
  }

  /**
   * 文件上传
   * @param data
   * @returns
   */
  static uploadFile(data: any): Promise<any> {
    return request.post(Api.UPLOAD_FILE, data, false, 'multipart/form-data')
  }

  /**
   * 邮箱发送短信验证码
   * @param data
   * @returns
   */
  static sendSMS(data: any): Promise<any> {
    return request.post(Api.SEND_SMS, data)
  }
}
